module.exports = __webpack_public_path__ + "static/media/logoWhite.80b72839.svg";